module.exports = __webpack_public_path__ + "img/tx.beb9c303.png";